(function(){
  'use strict';

  if (window.__nestLreCartModalDirectFix20260707 === 'native-renewal-popup-v1') return;
  window.__nestLreCartModalDirectFix20260707 = 'native-renewal-popup-v1';

  var cartRootSelector = '.cart-modal,#CartDrawer,.cart-drawer,.drawer--cart,.ajax-cart,.ajaxcart,[data-cart-drawer],[data-cart-container]';
  var cartRowSelector = '.cart-item,[data-cart-item],.cart__row,.cart__item,.ajaxcart__product,.ajax-cart__item,[class*="cart-item" i],[class*="cart__item" i]';
  var triggerSelector = '.renewal-popup-icon,#recycle_fee,[data-lre-modal-trigger],[aria-label*="Lifetime Renewal" i],[title*="Lifetime Renewal" i]';
  var fallbackId = 'nest-lre-cart-modal-direct';
  var activeTrigger = null;

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function removeFallbackModal() {
    var fallback = document.getElementById(fallbackId);
    if (fallback && fallback.parentNode) fallback.parentNode.removeChild(fallback);
  }

  function nativeContainer() {
    return document.querySelector('#shopify-section-renewal-popup .renewal-popup-container, .renewal-popup-container');
  }

  function nativePopup() {
    var container = nativeContainer();
    return container ? container.querySelector('.renewal-popup') : null;
  }

  function closestCartRoot(element) {
    return element && element.closest ? element.closest(cartRootSelector) : null;
  }

  function triggerFromTarget(target) {
    if (!target || !target.closest) return null;

    var trigger = target.closest(triggerSelector);
    if (!trigger || !closestCartRoot(trigger)) return null;

    var row = trigger.closest(cartRowSelector);
    var rowText = clean((row || closestCartRoot(trigger)).textContent);
    if (!/Lifetime Renewal Exchange|Renewal Exchange/i.test(rowText)) return null;

    return trigger;
  }

  function cartPanelFor(trigger) {
    return trigger.closest('.cart-modal-viewport') ||
      trigger.closest('.cart-modal') ||
      trigger.closest('#CartDrawer') ||
      trigger.closest('.cart-drawer') ||
      trigger.closest('.drawer--cart') ||
      closestCartRoot(trigger) ||
      document.documentElement;
  }

  function visibleRect(element) {
    if (!element || !element.getBoundingClientRect) return null;
    var rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    return rect;
  }

  function positionPopup(trigger) {
    var container = nativeContainer();
    var popup = nativePopup();
    if (!container || !popup) return;

    var panel = cartPanelFor(trigger);
    var panelRect = visibleRect(panel) || { top: 0, left: 0, right: window.innerWidth, bottom: window.innerHeight, width: window.innerWidth, height: window.innerHeight };
    var triggerRect = visibleRect(trigger) || panelRect;

    container.style.setProperty('display', 'block', 'important');
    container.style.setProperty('visibility', 'visible', 'important');
    container.style.setProperty('opacity', '1', 'important');
    container.style.setProperty('position', 'fixed', 'important');
    container.style.setProperty('inset', '0', 'important');
    container.style.setProperty('z-index', '2147483000', 'important');
    container.style.setProperty('background', 'transparent', 'important');
    container.style.setProperty('pointer-events', 'none', 'important');
    container.removeAttribute('hidden');
    container.setAttribute('aria-hidden', 'false');
    container.classList.add('active', 'is-active', 'nest-lre-native-cart-open');

    popup.style.setProperty('display', 'block', 'important');
    popup.style.setProperty('visibility', 'visible', 'important');
    popup.style.setProperty('opacity', '1', 'important');
    popup.style.setProperty('position', 'fixed', 'important');
    popup.style.setProperty('pointer-events', 'auto', 'important');
    popup.style.setProperty('z-index', '2147483001', 'important');

    var popupRect = popup.getBoundingClientRect();
    var width = popupRect.width || Math.min(340, Math.max(280, panelRect.width - 32));
    var height = popupRect.height || 220;
    var gutter = 14;
    var leftMin = Math.max(8, panelRect.left + gutter);
    var leftMax = Math.max(leftMin, Math.min(window.innerWidth - width - 8, panelRect.right - width - gutter));
    var left = Math.min(Math.max(triggerRect.right - width, leftMin), leftMax);
    var top = triggerRect.bottom + 10;

    if (top + height > panelRect.bottom - gutter) {
      top = triggerRect.top - height - 10;
    }
    if (top < panelRect.top + gutter) {
      top = Math.min(Math.max(panelRect.top + Math.round((panelRect.height - height) / 2), panelRect.top + gutter), Math.max(panelRect.top + gutter, panelRect.bottom - height - gutter));
    }

    popup.style.setProperty('left', Math.round(left) + 'px', 'important');
    popup.style.setProperty('top', Math.round(top) + 'px', 'important');
    popup.style.setProperty('right', 'auto', 'important');
    popup.style.setProperty('bottom', 'auto', 'important');
    popup.style.setProperty('max-width', Math.max(260, Math.min(360, panelRect.width - gutter * 2)) + 'px', 'important');
  }

  function closeNativePopup() {
    var container = nativeContainer();
    var popup = nativePopup();
    activeTrigger = null;

    if (container) {
      container.classList.remove('active', 'is-active', 'nest-lre-native-cart-open');
      container.setAttribute('aria-hidden', 'true');
      container.style.setProperty('display', 'none', 'important');
      container.style.setProperty('visibility', 'hidden', 'important');
      container.style.setProperty('opacity', '0', 'important');
      container.style.removeProperty('pointer-events');
    }

    if (popup) {
      ['position','left','top','right','bottom','max-width','pointer-events','z-index','display','visibility','opacity'].forEach(function(property){
        popup.style.removeProperty(property);
      });
    }
  }

  function openNativePopup(trigger) {
    var container = nativeContainer();
    var popup = nativePopup();
    if (!container || !popup) return false;

    removeFallbackModal();
    activeTrigger = trigger;
    positionPopup(trigger);
    window.setTimeout(function(){ positionPopup(trigger); }, 40);
    window.setTimeout(function(){ positionPopup(trigger); }, 180);

    var close = popup.querySelector('.renewal-popup-close, button, [role="button"]');
    if (close && close.focus) {
      try { close.focus({ preventScroll: true }); } catch (error) { close.focus(); }
    }

    return true;
  }

  document.addEventListener('click', function(event) {
    var trigger = triggerFromTarget(event.target);
    if (!trigger) return;

    if (openNativePopup(trigger)) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var trigger = triggerFromTarget(event.target);
    if (!trigger) return;

    if (openNativePopup(trigger)) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', function(event) {
    var container = nativeContainer();
    var popup = nativePopup();
    if (!container || !container.classList.contains('nest-lre-native-cart-open')) return;

    if (event.target.closest && event.target.closest('.renewal-popup-close')) {
      event.preventDefault();
      closeNativePopup();
      return;
    }

    if (popup && !popup.contains(event.target) && !triggerFromTarget(event.target)) {
      closeNativePopup();
    }
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' || event.key === 'Esc') closeNativePopup();
  }, true);

  ['resize', 'orientationchange', 'scroll'].forEach(function(eventName) {
    window.addEventListener(eventName, function() {
      if (activeTrigger) positionPopup(activeTrigger);
    }, true);
  });

  document.addEventListener('refreshAjaxCart', closeNativePopup, true);
  document.addEventListener('cart:refresh', closeNativePopup, true);
  document.addEventListener('refreshCart', closeNativePopup, true);
})();
